import { get } from './APIHelper';

export const getPlayerData = async (sport, playerId) => {
  return get(`proxy/api/v1/players/player?sport=${sport}&playerId=${playerId}`);
};
